import './index.scss';
import { useMediaQuery } from 'react-responsive';
import { FormattedMessage, useIntl } from 'react-intl';
import Popup from '../../Commons/Components/Popup';
import CheckIcon from '../../Assets/Images/icon-checkbox-checked.png';
import UncheckIcon from '../../Assets/Images/icon-checkbox-unchecked.png';
import { useMemo } from 'react';

import Refund from '../../Commons/Components/Terms/Refund';
import Information from '../../Commons/Components/Terms/Information';
import Otherpay from '../../Commons/Components/Terms/Otherpay';
import Buying from '../../Commons/Components/Terms/Buying';

const View = ({
  isLoading,
  paymentData,
  onClickPaymentImplement,
  onClickToggleAgreementTerms,
  paymentImplementIndex,
  agreementTerms,
  isValidation,
  onClickPayment,
  implementList,
  totalApplyDiscountedPrice,
  isLoggedIn,
}) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isForeigner = false;

  const formatCurrency = (value, type) => {
    return type === 'rate'
      ? `${value}%`
      : `${(isForeigner ? Math.round(value) : Math.round(value / 100) * 100)
          .toFormattedPrice()
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${
          isForeigner
            ? '$'
            : formatMessage({
                id: 'CURRENCY_KOR',
              })
        }`;
  };

  const terms = useMemo(
    () => [
      {
        key: 'refund',
        titleId: 'REFUND_POLICY',
      },
      {
        key: 'information',
        titleId: 'CONSENT_TO_PROVISION_OF_PERSONAL_INFORMATION_TO_THIRD_PARTIES',
      },
      {
        key: 'otherpay',
        titleId: 'AGREE_TO_THE_TERMS_OF_USE_FOR_PAYMENT_AGENCY_SERVICE',
      },
      {
        key: 'buying',
        titleId: 'PURCHASE_CONFIRMATION_AGREEMENT',
      },
    ],
    [],
  );

  if (isLoading) {
    return null;
  }

  return (
    <>
      <div className="payment_wrap">
        <div className="inner_wrap">
          <div className="payment_form">
            <div className="payment_form-title">
              <FormattedMessage id="PAYMENT" />
            </div>

            <div className="payment_list_wrap">
              <h3>
                <FormattedMessage id="PAYMENT_LIST" />
              </h3>
              <div className="payment_list_box">
                <div className="payment_list">
                  <h4>{paymentData.FK_class.title || ''}</h4>
                  {!isMobile && (
                    <div className="price_box">
                      <span className={`price`}>{formatCurrency(paymentData.price)}</span>
                    </div>
                  )}
                </div>
                <div className="coupon_select_wrap">
                  {isMobile && (
                    <div className="price_box">
                      <span className={`price`}>{formatCurrency(paymentData.price)}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="payment_implement_list_wrap">
              <h3>
                <FormattedMessage id="PAYMENT_METHOD" />
              </h3>
              <ul className="payment_implement_list_box">
                {!paymentData.price && (
                  <li className="isActive">
                    <FormattedMessage id="PAYMENT_IMPLEMENTS_FREE" />
                  </li>
                )}
                {!!paymentData.price &&
                  implementList?.map((list, index) => (
                    <li
                      key={`${list}_${index}`}
                      className={paymentImplementIndex === index ? 'isActive' : ''}
                      onClick={() => {
                        !!totalApplyDiscountedPrice && onClickPaymentImplement(index);
                      }}
                    >
                      <FormattedMessage id={list.key} />
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="payment_terms_box">
            <div className="payment_terms_box-title">
              <FormattedMessage id="AMOUNT_OF_PAYMENT" />
            </div>
            <div className="price_history">
              <div className="price_history_priceWrap">
                <span className="label">
                  <FormattedMessage id="TOTAL_AMOUNT" />
                </span>
                <div className="price">{formatCurrency(paymentData.price)}</div>
              </div>
              <div className="price_history_priceWrap">
                <span className="label">
                  <FormattedMessage id="USE_COUPON" />
                </span>
              </div>
              <div className="total_price_history">
                <span className="label">
                  <FormattedMessage id="TOTAL_AMOUNT_DUE" />
                </span>
                <strong className="total_price">{formatCurrency(totalApplyDiscountedPrice)}</strong>
              </div>
            </div>

            <div className="payment_terms">
              <div className="agreement" onClick={onClickToggleAgreementTerms}>
                <span className="checkbox">
                  <img src={agreementTerms ? CheckIcon : UncheckIcon} alt="payment_agree_terms" />
                </span>
                <strong>
                  <FormattedMessage id="CONFIRM_OF_ORDER_DETAIL_AND_AGREE" />
                </strong>
              </div>

              <ul className="terms_list_box">
                {terms.map((term) => (
                  <li key={term.key}>
                    <FormattedMessage id={term.titleId} />
                    <Popup
                      modal
                      trigger={
                        <span>
                          <FormattedMessage id="COMMON_READ_MORE" />
                        </span>
                      }
                    >
                      {term.key === 'refund' && <Refund />}
                      {term.key === 'information' && <Information />}
                      {term.key === 'otherpay' && <Otherpay />}
                      {term.key === 'buying' && <Buying />}
                    </Popup>
                  </li>
                ))}
              </ul>
            </div>

            <button
              id="payment_complete_click"
              className="payment_btn"
              disabled={!isValidation}
              onClick={onClickPayment}
            >
              <FormattedMessage id="COMMON_PAYMENT" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
